export default __webpack_public_path__ + "media/images/gallery/10-db8bb8140c36ef5f9e14219685759a69.jpg";